import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';

//elements
import { NumberInput, Input } from '../../../../../elements/Input';
import SwitchWidget from '../../SwitchWidget';

//utils
import { currentYearCycle } from '../../../../../utils/commonMethods';
import { CLIENT_RULE_CHANGE_VALIDATORS } from '../../../../../utils/constants';

class CollectiveAgreement extends Component {
    constructor(props) {
        super(props);
        const { currentEntity } = props.clientStore;
        const basicRules = Object.assign({}, currentEntity.client.data.basicRules);
        this.state = {
            collectiveAgreementLeaves: {
                isCollectiveAgreementLeavesEditable: false,
                allowCollectiveAgreementLeave: basicRules.allowCollectiveAgreementLeave,
                collectiveAgreementLeaveDays: basicRules.collectiveAgreementLeaveDays,
            },
        }
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange = (name, value) => {
        const { collectiveAgreementLeaves } = this.state;
        const { clientStore, commonStore, t } = this.props;

        collectiveAgreementLeaves[name] = value;
        this.props.handleUserDataChange(name, value);

        if (name === 'allowCollectiveAgreementLeave') {
            if (value) {
                const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
                const collectiveAgreementType = extendedRules.absent_types.find((item) => item.code === 'collective-agreement');
                if (!collectiveAgreementType) {
                    extendedRules.absent_types.unshift({ code: 'collective-agreement', name: 'Collective Agreement' });
                }
                this.props.handleClientRuleChange('extendedRules', extendedRules);
            } else {
                const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
                const absenceTypes = extendedRules.absent_types.filter((item) => item.code !== 'collective-agreement');
                extendedRules.absent_types = absenceTypes;
                this.props.handleClientRuleChange('extendedRules', extendedRules);
            }
        }

        if (name === 'collectiveAgreementLeaveDays') {
            const extendedRules = Object.assign({}, clientStore.currentEntity.client.data.extendedRules);
            this.props.handleClientRuleChange('extendedRules', extendedRules)
            if (value < clientStore.validateClientRuleChangeResponse.collectiveAgreement.maxCollectiveAgreementLeaveDaysUsed) {
                commonStore.addNotification(t('Collective agreement leave days can not be less than used days' + ' ' + clientStore.validateClientRuleChangeResponse.collectiveAgreement.maxCollectiveAgreementLeaveDaysUsed), null, 'warning', 'top-right', 3000);
            }
        }

        this.setState({ collectiveAgreementLeaves });
    }

    handleCollectiveAgreementLeavesEdit = async () => {
        const { clientStore } = this.props;

        await clientStore.validateClientRuleChange({ changeType: CLIENT_RULE_CHANGE_VALIDATORS.ABSENCE_COLLECTIVE_AGREEMENT_LEAVE_CHANGE }, 'absence');

        this.setState({
            collectiveAgreementLeaves: {
                ...this.state.collectiveAgreementLeaves,
                isCollectiveAgreementLeavesEditable: !this.state.collectiveAgreementLeaves.isCollectiveAgreementLeavesEditable
            }
        })
    }

    render() {
        const { collectiveAgreementLeaves } = this.state;
        const { t, commonStore } = this.props;

        const dateTimeRules = commonStore.getDateTimeRules();
        const { short_date_format } = dateTimeRules;
        const timezoneGMT = commonStore?.config?.timezoneGMT || 0;

        return (
            <div>
                <div className="d-flex align-items-center justify-content-start mt-2 gap-3 w-100">
                    <div className="d-flex align-items-center">
                        <label className="control-label font-size-15 mb-0 font-color-primary">
                            {t('Collective Agreement')}
                            <OverlayTrigger
                                placement="bottom"
                                overlay={
                                    <Tooltip id="tooltip-top">
                                        {t("Enable Collective Agreement Leave")}.
                                    </Tooltip>
                                }
                            >
                                <i
                                    className="fa fa-info-circle text-muted ms-1"
                                    style={{ opacity: 0.5 }}
                                    aria-hidden="true"
                                />
                            </OverlayTrigger>
                        </label>
                    </div>
                    <div className="d-flex align-items-center">
                        <OverlayTrigger
                            placement="right"
                            overlay={
                                <Tooltip id="Edit-CollectiveAgreement">
                                    {t("Enable edit mode")}
                                </Tooltip>
                            }
                        >
                            <i
                                className="fa fa-edit font-size-15 cursor-pointer font-color-primary mt-1"
                                onClick={() => this.handleCollectiveAgreementLeavesEdit()}
                            />
                        </OverlayTrigger>
                    </div>
                </div>
                <hr />
                <Row className='mt-2'>
                    <Col xs={12} md={6}>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Enable Collective Agreement Leave')}</label>
                            </Col>
                            <Col xs={4}>
                                <SwitchWidget
                                    value={collectiveAgreementLeaves.allowCollectiveAgreementLeave}
                                    disabled={!collectiveAgreementLeaves.isCollectiveAgreementLeavesEditable}
                                    onChange={(checked) => this.handleChange('allowCollectiveAgreementLeave', checked)}
                                />
                            </Col>
                        </Row>
                        <Row className='mt-2 align-items-center'>
                            <Col xs={8}>
                                <label className="control-label">{t('Collective Agreement Leave Days')}</label>
                            </Col>
                            <Col xs={4}>
                                <NumberInput
                                    value={collectiveAgreementLeaves.collectiveAgreementLeaveDays}
                                    disabled={!collectiveAgreementLeaves.isCollectiveAgreementLeavesEditable}
                                    onChange={evt => this.handleChange('collectiveAgreementLeaveDays', parseInt(evt.target.value, 10))}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={6}>
                        <Row className='align-items-center'>
                            <Col xs={4}>
                                <label className="control-label">{t('Leave Cycle')}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={
                                            <Tooltip id="tooltip-top">
                                                {t("The collective agreement leave cycle follows the calendar year, and the leaves allocated to employees resets at the beginning of the year")}.
                                            </Tooltip>
                                        }
                                    >
                                        <i className="fa fa-info-circle text-muted ms-1" style={{ opacity: '0.5' }} aria-hidden="true"></i>
                                    </OverlayTrigger>
                                </label>
                            </Col>
                            <Col xs={7}>
                                <Input
                                    disabled
                                    onChange={_ => { }}
                                    value={currentYearCycle(short_date_format, timezoneGMT)}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </div >
        );
    }
}
export default inject('clientStore', 'commonStore')(withLocalization(observer(CollectiveAgreement)));
